import { atom } from "recoil";

export const ModalAtom = atom({
    key: "ModalAtomefnbewfkerjfhnf",
    default: {
        createTestimoni: {
            show: false,
            data: null
        },
        editTestimoni: {
            show: false,
            data: null
        },
        detailOpportunity: {
            show: false,
            data: {
                oppId: null
            },
        },
        createCategory: {
            show: false,
            data: null
        },
        editCategory: {
            show: false,
            data: null
        }
    }
})